// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a8203e5d","404":"214dc001","498":"82dc3461"}[chunkId] + ".chunk.js";
};